// * Bootstrap libraries
import './_bootstrap';

(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.ajaxAnimationReplacement = {
    attach(context) {

      /**
       * Build loader markup.
       */

      function loaderMarkup(
        label = Drupal.t('Loading content...'),
        type = 'spinner'
      ) {

        const loaders = {

          spinner: `
            <div
              class="aso-loader aso-loader--spinner"
              aria-hidden="true">
            </div>
          `,

          bounce: `
            <div
              class="aso-loader aso-loader--bounce"
              aria-hidden="true">

              <div class="bounce_one"></div>
              <div class="bounce_two"></div>

            </div>
          `,

          dots: `
            <div
              class="aso-loader aso-loader--dots"
              aria-hidden="true">

              <span></span>
              <span></span>
              <span></span>

            </div>
          `,
        };

        return `
          <div
            class="aso-progress-container"
            role="status"
            aria-live="polite"
            aria-atomic="true"
            aria-busy="true"
            aria-labelledby="aso-loader-message">

            <div class="aso-progress-inner">

              ${loaders[type] || loaders.spinner}

              <span
                class="aso-loader__label"
                id="aso-loader-message">

                ${label}

              </span>

            </div>

          </div>
        `;
      }

      /**
       * Override Drupal core AJAX indicators.
       */
      Drupal.theme.ajaxProgressThrobber = () =>
        loaderMarkup(
          Drupal.t('Loading content...'),
          'spinner'
        );

      Drupal.theme.ajaxProgressIndicatorFullscreen = () =>
        loaderMarkup(
          Drupal.t('Loading page...'),
          'spinner'
        );

      once('aso-global-loader', 'body', context).forEach(() => {

        const loader = document.createElement('div');

        loader.id = 'aso-global-loader';
        loader.style.display = 'none';

        document.body.appendChild(loader);

        let loaderTimer = null;
        /**
         * These preserve context between submit and ajaxSend.
         */
        let currentLoaderLabel = Drupal.t('Loading content...');
        let currentLoaderType = 'spinner';  //'bounce' or 'dots' 
        
        let loaderActive = false;
        /**
         * Show loader.
         */
        function showLoader(
          label = Drupal.t('Loading content...'),
          type = currentLoaderType
        ) {

          currentLoaderLabel = label;
          currentLoaderType = type;

          clearTimeout(loaderTimer);

          loaderTimer = setTimeout(() => {

            loader.innerHTML = loaderMarkup(
              currentLoaderLabel,
              currentLoaderType
            );

            loaderActive = true;
            document.body.setAttribute(
              'aria-busy',
              'true'
            );

            loader.style.display = 'block';

          }, 400);

        }

        /**
         * Hide loader.
         */
        function hideLoader() {

          clearTimeout(loaderTimer);

          document.body.removeAttribute('aria-busy');

          loader.style.display = 'none';
          loader.innerHTML = '';
          loaderActive = false;
          currentLoaderLabel =
            Drupal.t('Loading content...');

       //   currentLoaderType = 'spinner';
          
        }

        /**
         * Full page navigation.
         */
        document.addEventListener('click', (e) => {

          const link = e.target.closest('a');

          if (!link) {
            return;
          }

          if (
            e.ctrlKey ||
            e.metaKey ||
            e.shiftKey ||
            e.altKey ||
            e.defaultPrevented ||
            (link.target &&  link.target !== '_self') ||
            link.hasAttribute('download') ||
            link.href.startsWith('mailto:') ||
            link.href.startsWith('tel:') ||
            link.href.includes('#') ||
            link.origin !== window.location.origin ||
            link.getAttribute('aria-expanded') !== null ||
            link.getAttribute('role') === 'button' ||
            link.href.endsWith('javascript:void(0)') ||
            link.href === window.location.href
          ) {
            return;
          }

          setTimeout(() => {

            if (e.defaultPrevented) {
              return;
            }

            showLoader(
              Drupal.t('Loading page...'),
              currentLoaderType
            );

          }, 0);

        });

        /**
         * Form submissions.
         */
        
        document.addEventListener('submit', (e) => {

          
          const form = e.target;

          if (
            form.matches('.views-exposed-form')
          ) {

            showLoader(
              Drupal.t('Searching results...'),
              currentLoaderType
            );

            return;
          }

          if (
            form.classList.contains(
              'webform-submission-form'
            )
          ) {

            showLoader(
              Drupal.t('Submitting form...'),
              currentLoaderType
            );

            return;
          }

          showLoader(
            Drupal.t('Loading page......'),
            currentLoaderType
          );

        });

        /**
         * Native Drupal AJAX.
         *
         * Re-use the current context rather than
         * replacing it with "Loading content...".
         */
        document.addEventListener('ajaxSend', () => {

          if (!loaderActive) {
            showLoader(
              currentLoaderLabel,
              currentLoaderType
            );
          }    
        });

        document.addEventListener(
          'ajaxComplete',
          hideLoader
        );

        /**
         * jQuery fallback.
         */
        if (window.jQuery) {

          window.jQuery(document)
            .ajaxStart(() => {

              showLoader(
                currentLoaderLabel,
                currentLoaderType
              );

            })
            .ajaxStop(hideLoader);
        }

        /**
         * Browser navigation events.
         */
        window.addEventListener(
          'pageshow',
          hideLoader
        );

        window.addEventListener(
          'load',
          hideLoader
        );

        /**
         * Page unload.
         */
/*         window.addEventListener(
          'beforeunload',
          () => {


            if (formSubmitting) {
              return;
            }

            showLoader(
              Drupal.t('Loading page...'),
              'spinner'
            );

          }
        ); */ 

      });
    },
  };
})(Drupal, once);
